import React from "react";
import { Button } from "reactstrap";
import { startSpotifyLogin } from "./../auth/SpotifyAuth.js";

const scopes = [
  "playlist-read-collaborative",
  "playlist-read-private",
  "playlist-modify-private",
  "ugc-image-upload",
];

export default function LoginButton() {
  return (
    <Button
      outline
      color="success"
      className="LoginBtn"
      onClick={() => startSpotifyLogin(scopes)}
    >
      login with Spotify!
    </Button>
  );
}
